<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <page-video
            :contentEnabled="contentEnabled"
            videoSrc="videos/ipadAir-video.mp4"
          ></page-video>
          <div class="content">
            <img
              src="./products/ipadAir-logo.svg"
              class="product-logo"
              style="max-width: 28%"
            />
            <h2>All-out performance. <br />All-new colours.</h2>
            <p>
              iPad Air, now with 10.9-inch Liquid Retina display and True Tone.
              Powered by the new A14 Bionic chip with Neural Engine for 4K video
              editing, music creation and next-level games.
            </p>
            <a
              target="_blank"
              href="https://shop.singtel.com/phones/apple-ipad-8th-gen/apple-ipad-air-4?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=ipad-air-buynow&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Buy Now
            </a>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/info/ipadair?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=ipad-air-learnmore&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Learn More
            </a>
            <p class="small">T&amp;Cs apply.</p>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "IpadAirPage",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
